import {Box, Stack, Typography, CircularProgress} from '@mui/material';
import {URLPathname} from 'interfaces';
import {Navigate, useRouteError} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

export const ErrorBoundary = () => {
  const {t} = useTranslation('common');
  const error = useRouteError();

  if (error instanceof Error && error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload();
    return (
      <Box width={'100vw'} height={'100vh'} bgcolor={'background.default'}>
        <Stack p={2} direction={'row'} spacing={2}>
          <CircularProgress size={18} />
          <Typography variant="body2" color="text.primary">
            {t('applicationUpdating')}
          </Typography>
        </Stack>
      </Box>
    );
  } else if (error && typeof error === 'object' && 'status' in error && error.status === 404) {
    return <Navigate to={URLPathname.root} replace />;
  }

  throw error;
};
